import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Regioverantwoordelijke} from '../../../regioverantwoordelijke/regioverantwoordelijke';
import {Observable} from 'rxjs';
import {RegioverantwoordelijkeService} from '../../../regioverantwoordelijke/regioverantwoordelijke.service';
import {map, mergeMap} from 'rxjs/operators';

@Component({
    templateUrl: './regioverantwoordelijke.page.html',
    styleUrls: ['./regioverantwoordelijke.page.scss'],
    standalone: false
})
export class RegioverantwoordelijkePage implements OnInit {
  private regioverantwoordelijkeService = inject(RegioverantwoordelijkeService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  regioverantwoordelijke$: Observable<Regioverantwoordelijke>;

  ngOnInit(): void {
    this.regioverantwoordelijke$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.regioverantwoordelijkeService.getRegioverantwoordelijkeById$(id)),
      );
  }

  onCancelClicked(): void {
    this.navigateToRegioverantwoordelijken();
  }

  onEditClicked(regioverantwoordelijke: Regioverantwoordelijke): void {
    this.regioverantwoordelijkeService.updateRegioverantwoordelijke$(regioverantwoordelijke)
      .subscribe(() => this.navigateToRegioverantwoordelijken());
  }

  private navigateToRegioverantwoordelijken(): void {
    this.router.navigateByUrl('/regioverantwoordelijken');
  }
}
